(function() {
  const container = document.createElement('div');
  container.id = 'toast-container';
  container.style.cssText = 'position:fixed;top:20px;right:20px;z-index:99999;display:flex;flex-direction:column;gap:10px;pointer-events:none;';
  document.body.appendChild(container);

  function showToast(message, type) {
    const toast = document.createElement('div');
    toast.className = 'bb-toast bb-toast--' + type;
    toast.innerHTML = '<span class="bb-toast__icon">' + getIcon(type) + '</span><span class="bb-toast__message">' + message + '</span>';
    toast.style.cssText = 'pointer-events:auto;display:flex;align-items:center;gap:10px;padding:14px 20px;border-radius:8px;font-size:14px;font-weight:500;color:#fff;box-shadow:0 4px 12px rgba(0,0,0,0.15);transform:translateX(120%);transition:transform 0.3s ease,opacity 0.3s ease;opacity:0;';

    const colors = { success: '#D54C6A', remove: '#91425F', error: '#e74c3c' };
    toast.style.background = colors[type] || colors.success;

    container.appendChild(toast);

    requestAnimationFrame(function() {
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    });

    setTimeout(function() {
      toast.style.transform = 'translateX(120%)';
      toast.style.opacity = '0';
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  function getIcon(type) {
    const icons = {
      success: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
      remove: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/></svg>',
      error: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6"/><path d="M9 9l6 6"/></svg>'
    };
    return icons[type] || icons.success;
  }

  window.BakedBeautyToast = { show: showToast };

  let previousCartCount = null;

  document.addEventListener('product-ajax:added', function(event) {
    const productTitle = event.detail.product.title || 'Product';
    showToast(productTitle + ' added to cart', 'success');
  });

  document.addEventListener('cart:updated', function(event) {
    const cart = event.detail.cart;
    const currentCount = cart.item_count;

    previousCartCount !== null && currentCount < previousCartCount && showToast('Item removed from cart', 'remove');
    previousCartCount = currentCount;
  });

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    previousCartCount = cart.item_count;
  });
})();
